import { Api, LimitedSizeMap, MenuItem, StringUtil } from "@mcleod/core";
import { DatabaseMenuItem } from "./DatabaseMenuItem";
import { RowWebMenuItemFields } from "../models/autogen/AutogenModelWebMenuItem";

interface InFlight {
    [path: string]: Promise<Partial<RowWebMenuItemFields>>;
}


export class MenuItemDefaults {
    private static readonly endpoint = "lib/menu-item-defaults";
    private static cache = new LimitedSizeMap<string, MenuItem>(100);
    private static inFlightApiCalls: InFlight = {};

    public static getStandardDefaults(): Partial<RowWebMenuItemFields> {
        return {
            company_type: "L",
            ide_only: "N",
            local_only: "N",
            mcleod_only: "N",
            visible: "Y"
        };
    }

    public static get(path: string): Promise<Partial<RowWebMenuItemFields>> {
        if (!this.isValidLayoutPath(path)) {
            return Promise.resolve(null);
        }

        if (this.inFlightApiCalls[path]) {
            return this.inFlightApiCalls[path];
        }

        const cached = this.cache.get(path);
        if (cached) {
            return Promise.resolve({...cached});
        }

        this.inFlightApiCalls[path] = Api.search(MenuItemDefaults.endpoint, { path })
            .then(response => {
                const menuItem = response as MenuItem;
                this.cache.set(path, menuItem);
                delete this.inFlightApiCalls[path];
                return { ...menuItem };
            }).catch(error => {
                delete this.inFlightApiCalls[path];
                throw error;
            });

        return this.inFlightApiCalls[path];
    }

    private static isValidLayoutPath(path: string): boolean {
        return !StringUtil.isEmptyString(path) &&  !DatabaseMenuItem.isExternalPath(path);
    }

    public static clear(): void {
        this.cache.clear();
        this.inFlightApiCalls = {};
    }
}
